import { GkashPaymentDetail } from '@share/interfaces';
import { useDebouncedCallback } from 'use-debounce';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Params {
  prepayHook: () => Promise<GkashPaymentDetail | null>;
}

function GkashPaymentBtn(param: Params): JSX.Element {
  /* Define state / hook */
  const { t } = useTranslation();
  const paymentForm = useRef<HTMLFormElement>(null);

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */
  const createInput = (name: string, value: string) => {
    const input = document.createElement('input');

    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);

    return input;
  };

  const handleSubmit = useDebouncedCallback(
    async () => {
      const details = await param.prepayHook();

      if (!details) return;
      if (!paymentForm?.current) return;

      paymentForm.current.setAttribute('action', details.post_url);
      const entries = Object.entries(details);
      for (let i = 0; i < entries.length; i += 1) {
        const entry = entries[i];
        paymentForm.current.appendChild(createInput(entry[0], entry[1]));
      }
      paymentForm.current.submit();
    },
    500,
    { leading: true, trailing: false }
  );

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <>
      <form ref={paymentForm} method="POST" />
      <button
        aria-label={t('modal.payByGkash')}
        className="btn btn-primary mt-4"
        data-test="fiat-minting-btn"
        type="button"
        onClick={() => handleSubmit()}
      >
        {t('modal.payByGkash')}
      </button>
    </>
  );
}

export default GkashPaymentBtn;
